// extracted by mini-css-extract-plugin
module.exports = {"learnMoreContainer":"learn-more_learnMoreContainer__kbTsj","contentContainer":"learn-more_contentContainer__OPTmk","moreInfo":"learn-more_moreInfo__XSCaR"};